import { fetchGdsInfo } from './api/auth.service';
import to from '../utils/to';
import AsyncStoreService from './async-store.service';

const buildRequestUrl = (fromCity, toCity, callNo) => {
  //const { fromCity, toCity, fromDate, toDate } = searchCriteria;
  let isDepartDateSelectedEvent = false; // fromDate && toDate;
  if (callNo === 0) {
    isDepartDateSelectedEvent = false;
  }
  let searchUrl = '';

  const los = calculateLos(callNo, isDepartDateSelectedEvent);

  if (isDepartDateSelectedEvent) {
    // const departureDate = fromDate;
    // searchUrl = `/v2/shop/flights/fares?origin=${fromCity}&destination=${toCity}&lengthofstay=${los}&departuredate=${departureDate}`;
  } else {
    searchUrl = `/v2/shop/flights/fares?origin=${fromCity}&destination=${toCity}&lengthofstay=${los}`;
  }
  return searchUrl;
};

const calculateLos = (callNo, isDepartDateSelectedEvent) => {
  let los = '';
  if (isDepartDateSelectedEvent) {
    if (callNo == 1) {
      los = '1,2,3,4,5,6,7,8,9';
    } else if (callNo == 2) {
      los = '10,11,12,13,14,15,16';
    }
  } else {
    los = '3,8';
  }
  return los;
};

export const fetchLowPriceFares = async (fromCity, toCity, callNo) => {
  const gdsInfo = await fetchGdsInfo();

  const url = buildRequestUrl(fromCity, toCity, callNo);
  try {
    const res = await fetch(`${gdsInfo.SabreAPIUrl}${url}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        Authorization: 'Bearer ' + gdsInfo?.SabreToken,
      },
    });

    const json = await res.json();

    // if request fails, just prevent error and don't show pricing.
    if (!res.ok) {
      return {};
    }

    const mappedLowPriceResults = mapLowPriceResults(json);

    console.log(mappedLowPriceResults);
    return mappedLowPriceResults;
  } catch (error) {
    return {};
  }
};

const mapLowPriceResults = (result) => {
  const lpcResponse = {};
  const airResponses = [];
  const tempArray = [];
  //Dest Data
  const firstarray = [];
  const specificPrices = [];
  let datimeAndPrice;
  let totalPrice = parseInt(0);
  let validNoOfPrices = parseInt(0);
  if (result?.FareInfo) {
    result.FareInfo.forEach((fare) => {
      const airResponse = {};
      airResponse.hasAir = true;
      //airResponse.origin = airLPC.Model.FromCityCode.toString(); TODO is this really needed?
      //airResponse.destination = airLPC.Model.ToCityCode.toString(); TODO is this really needed?
      airResponse.price = mapFarePrice(fare);
      airResponse.departureDateTime = fare.DepartureDateTime.split('T')[0];
      airResponse.returnDateTime = fare.ReturnDateTime.split('T')[0];
      airResponse.airlineCode = mapAirlineCode(fare);

      if (
        airResponse.price != 0 &&
        airResponse.airlineCode &&
        !(airResponse.airlineCode.indexOf('WN') > -1)
      ) {
        tempArray.push(airResponse);
      }
    });
  }
  tempArray.sort(function (a, b) {
    const aPrice = Math.round(parseFloat(a.price));
    const bPrice = Math.round(parseFloat(b.price));
    const aDepdate = Math.round(parseFloat(a.departureDateTime));
    const bDepdate = Math.round(parseFloat(b.departureDateTime));
    if (aDepdate == bDepdate) {
      return aPrice < bPrice ? -1 : 1;
    } else {
      return aDepdate < bDepdate ? -1 : 1;
    }
  });
  tempArray.forEach((fare) => {
    firstarray.push({
      departDate: fare.departureDateTime,
    });
    const fdata = firstarray.filter((e) => e.departDate == fare.departureDateTime);

    if (fdata.length === 1) {
      datimeAndPrice = `${fare.departureDateTime}:${fare.price}:${fare.returnDateTime}`;
      // '' + fare.departureDateTime + '' + ':' + '' + fare.price + ':' + fare.returnDateTime + '';
      specificPrices.push(datimeAndPrice);
      totalPrice += parseInt(fare.price);
      validNoOfPrices += parseInt(1);
      airResponses.push(fare);
    }
  });
  lpcResponse.fareResponse = airResponses;
  lpcResponse.avgPrice = Math.round(totalPrice / validNoOfPrices);
  return lpcResponse;
};

const mapFarePrice = (fare) => {
  return fare.LowestFare == 'N/A'
    ? fare.LowestNonStopFare == 'N/A'
      ? 0
      : Math.round(parseFloat(fare.LowestNonStopFare.Fare))
    : Math.round(parseFloat(fare.LowestFare.Fare));
};

const mapAirlineCode = (fare) => {
  return fare.LowestFare == 'N/A'
    ? fare.LowestNonStopFare == 'N/A'
      ? null
      : fare.LowestNonStopFare.AirlineCodes
    : fare.LowestFare.AirlineCodes;
};

const fetchSabreToken = async () => {
  // first check if we have a valid token, if so return it
  const storedToken = await AsyncStoreService.getSabreTokenData(sabreTokenData);
  if (storedToken) {
    if (isSabreTokenValid(storedToken)) {
      return storedToken;
    } else {
      await AsyncStoreService.removeSabreTokenData();
    }
  }

  const [err, gdsInfo] = await to(fetchGdsInfo());
  if (err) {
    throw 'failed to get gdsInfo for sabre token';
  }
  const res = await fetch(`${gdsInfo.SabreAPIUrl}/v2/auth/token`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      Authorization: 'Basic ' + gdsInfo.SabreToken,
    },
    body: 'grant_type=client_credentials',
  });
  const json = await res.json();
  if (!res.ok) {
    throw json;
  }
  const sabreTokenData = {
    accessToken: json.access_token,
    sessionAccessTime: new Date(),
    expiresIn: json.expires_in,
  };
  await AsyncStoreService.setSabreTokenData(sabreTokenData);
  return sabreTokenData;
};

const isSabreTokenValid = (sabreToken) => {
  const { accessToken, sessionAccessTime, expiresIn } = sabreToken;

  if (accessToken == null || sessionAccessTime == null || expiresIn == null) {
    return false;
  }
  const validDate = new Date(sessionAccessTime);
  validDate.setMinutes(validDate.getDate() + expiresIn / 60);

  if (Date.parse(Date()) > Date.parse(validDate)) {
    return false;
  } else {
    return true;
  }
};
